import 'init/sentry';

import React from 'react';
import { createRoot } from 'react-dom/client';

// Bundled rather than fetched from Google: the edge's CSP allows neither
// fonts.googleapis.com nor fonts.gstatic.com, so the stylesheet this replaces was
// blocked on every load and the app rendered in the Helvetica fallback.
import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';

import './colors.css';
import './index.css';
import App from './App';

const container = document.getElementById('root');
const root = createRoot(container!);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
